module.exports = __webpack_public_path__ + "assets/8048c42f969e92d7fe51f052916b06c7.svg";